<template name = "dateTemplate" lang="html">
		<!-- Create From -->
		<!-- Top bar-->
	<div class="row">
		<b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>
		<div id="header"></div>
		<div class="row">
			<div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
				<div class="sidebar-header">
					<h5>Search</h5>
					<a href="" id="sidebarMenuClose"><i data-feather="x"></i></a>
				</div><!-- df-sidebar-header -->
				<div class="sidebar-body"></div>
			</div><!-- sidebar-body -->
		</div><!-- sidebar -->
		<div class="content content-components">
			<div class="container pd-x-0 pd-lg-x-12 pd-xl-x-0 bs">  
				<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
					<div>
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb breadcrumb-style1 mg-b-10">
							<li class="breadcrumb-item">{{this.mainName}}</li>
							<li class="breadcrumb-item active" aria-current="page">{{this.subName}}</li>
							</ol>
							<h4 class="mg-b-0 tx-spacing--1">{{this.subName}}</h4>
						</nav>
					</div>
					<div class="d-none d-md-block">
						<button v-if="this.properties.uid" class="btn btn-sm pd-x-15 btn-danger btn-uppercase mg-l-5" v-on:click="deleteData()"><i data-feather="folder" class="wd-10 mg-r-5"></i>Delete</button>
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="createData()"><i data-feather="folder" class="wd-10 mg-r-5"></i>Save</button>
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="goList()"><i data-feather="file" class="wd-10 mg-r-5"></i>list</button>
					</div>
				</div>
				<div class="mg-t-100 bs2">
					<div class="card ht-100p">
						<form action="form-validation.html" data-parsley-validate class="card-body list-group list-group-flush tx-13list-group list-group-flush tx-13 d-block">
							<div class="form-row col-md-5 d-block">
								<div class="form-group">
									<label for="input1">Pipeline Name <span class="tx-danger">*</span></label>
									<input type="text" v-model.trim="name" class="form-control" ref="name" id="name" placeholder="Pipeline Name">
								</div>
							</div>
							<div class="form-row col-md-5 ">
								<div class="form-group">
									<label for="input1">Existing Pipeline <span class="tx-danger">*</span></label>
									 <b-select
                                        placeholder="Select a Pipeline"
                                        v-model="selTask" @change.native="selTaskHandler()">
                                        <option v-for="option in task" :value="option">
                                            {{ option.name }}
                                        </option>
                                    </b-select>
								</div>
								<div class="form-group" style="margin-left:20px">
									<label for="input1">Result <span class="tx-danger">*</span></label>
									 <b-select
									 	ref='resultMenu'
                                        placeholder="Select a Result"
                                        v-model="resultMenu" @change.native="">
                                        <option v-for="option in resultMenu_array" :value="option.menuId">
                                            {{ option.menuName }}
                                        </option>
                                    </b-select>
								</div>
							</div>
							<div class="form-row col-md-5">
								<div class="form-group">
									<label for="input1">Default <span class="tx-danger">*</span></label>
									 <b-field>
										<b-switch v-model="defaultSwitched"
											type="is-info"
											true-value="Yes"
											false-value="No"
											@change.native="defaultCheck()">				
											{{ defaultSwitched }}
										</b-switch>
									</b-field>
								</div>
							</div>
							<div class="form-row col-md-5">
								<div class="form-group">
									<label class="label-title">type <span class="tx-danger">*</span></label>
									<div class="input-group">
										<div class="ml-2 custom-control custom-radio mb-1">
											<input type="radio" ref="type" v-model.trim="type" name="type" id="type1" value="single" @change="typeCheck($event, 1)" class="custom-control-input">
											<label class="custom-control-label" for="type1">Single</label>
										</div>
										<div class="ml-2 custom-control custom-radio mb-1">
											<input type="radio" ref="type"  v-model.trim="type" name="type" id="type0" value="group" @change="typeCheck($event, 0)" class="custom-control-input form-check-input">
											<label class="custom-control-label" for="type0">Group</label>
										</div>
									</div>
								</div>
							</div>

							<div class="form-row col-md-5">
								<div class="form-group">
									<label class="label-title">Server Remote Host <span class="tx-danger">*</span></label>
									<div class="input-group">
										<div class="ml-2 custom-control custom-radio mb-1">
											<input type="radio" ref="remoteHost" v-model.trim="remoteHost" name="remoteHost" id="remoteHost1" value="accu01" @change="serverCheck($event, 1)" class="custom-control-input">
											<label class="custom-control-label" for="remoteHost1">accu01</label>
										</div>
										<div class="ml-2 custom-control custom-radio mb-1">
											<input type="radio" ref="remoteHost"  v-model.trim="remoteHost" name="remoteHost" id="remoteHost0" value="accu02" @change="serverCheck($event, 0)" class="custom-control-input form-check-input">
											<label class="custom-control-label" for="remoteHost0">accu02</label>
										</div>
									</div>
								</div>
							</div>

							<div class="form-row col-md-5 d-block">
								<div class="form-group">
									<label for="input4">Server User Name <span class="tx-danger">*</span></label>
									<input type="text" ref="remoteUserName" v-model.trim="remoteUserName" class="form-control" id="remoteUserName" placeholder="Pipeline Execution Shell Script RunFile">
								</div>
							</div>
					
							<div class="form-row col-md-5">
								<div class="form-group">
									<label class="label-title">FileName Extension <span class="tx-danger">*</span></label>
									<div class="input-group">
										<div class="ml-2 custom-control custom-radio mb-1">
											<input type="radio" ref="fileExtension" v-model.trim="fileExtension" name="fileExtension" id="fileExtension1" value="python" @change="extensionCheck($event, 1)" class="custom-control-input">
											<label class="custom-control-label" for="fileExtension1">Python</label>
										</div>
										<div class="ml-2 custom-control custom-radio mb-1">
											<input type="radio" ref="fileExtension"  v-model.trim="fileExtension" name="fileExtension" id="fileExtension0" value="shell" @change="extensionCheck($event, 0)" class="custom-control-input form-check-input">
											<label class="custom-control-label" for="fileExtension0">Shell</label>
										</div>
									</div>
								</div>
							</div>
							
							<div class="form-row col-md-5 d-block">
								<div class="form-group">
									<label for="input4">Pipeline Execution Shell Script RunFile <span class="tx-danger">*</span></label>
									<input type="text" ref="runFile" v-model.trim="runFile" class="form-control" id="runFile" placeholder="Pipeline Execution Shell Script RunFile">
								</div>
							</div>
							<div class="form-row col-md-5 d-block" v-if="this.type=='single'">
								<div class="form-group">
									<label for="input4">Pipeline Execution Shell Script ReportDataFile  <span class="tx-danger">*</span></label>
									<input type="text" ref="reportDataFile" v-model.trim="reportDataFile" class="form-control" id="reportDataFile" placeholder="Pipeline Execution Shell Script ReportDataFile">
								</div>
							</div>
							<div class="form-row col-md-5 d-block" v-if="this.type=='single'">
								<div class="form-group">
									<label for="input4">Pipeline Execution Shell Script ReporterFile  <span class="tx-danger">*</span></label>
									<input type="text" ref="reporterFile" v-model.trim="reporterFile" class="form-control" id="reporterFile" placeholder="Pipeline Execution Shell Script ReporterFile ">
								</div>
							</div>
							<div class="form-row col-md-5 d-block">
								<div class="form-group">
									<label for="input4">OutPutDir  <span class="tx-danger">*</span></label>
									<input type="text" ref="outPutDir" v-model.trim="outPutDir" class="form-control" id="outPutDir" placeholder="Please set the outPutDir">
								</div>
							</div>

							<div class="form-row col-md-12 d-block">
								<div class="form-group">
									<label for="input4">Parameter</label><a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-sm-b-10-f" data-toggle="modal" data-animation="effect-flip-horizontal" @click="addParameter"><feather type="plus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Add</a>
									<div v-for="(form, i) in param_array">
										<feather type="minus" @click="delParameter(i)" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow closed-cursor"></feather>
										<b-tooltip :label="'key'"
											position="is-bottom"
											:animated="false">
											<input type="text" :id="'key'+i" :value="form.key" @change="chgParameter(i,'key',$event)" placeholder="key" class="form-control d-inline w-auto">
										</b-tooltip>
										<b-tooltip :label="'value'"
											position="is-bottom"
											:animated="false">
											<input type="text" :id="'value'+i" :value="form.value" @change="chgParameter(i,'value',$event)" placeholder="value" class="form-control d-inline w-auto">
										</b-tooltip>
										<b-tooltip :label="'description'"
											position="is-bottom"
											:animated="false">
											<input type="text" :id="'message'+i" :value="form.message" @change="chgParameter(i,'message',$event)" placeholder="description" class="form-control d-inline">
										</b-tooltip>
										<div class="field d-inline">
											<b-checkbox :id="'fixed'+i" true-value="true" false-value="false":value="form.fixed" @change.native="chgParameter(i,'fixed',$event)" type="is-info">Fixed</b-checkbox>
										</div>
									</div>
								</div>

							</div>
						</form>
					</div><!-- card -->
				</div>		
			</div>
		</div>
	</div>
</template>

<script>
	import Handsontable from 'handsontable';
	import {HotTable} from '@handsontable/vue';
	import 'handsontable-key-value';
	import common from '@/views/Common/common.js';

	//암호화
	import {secretKey} from '@/config/config';
	import crypto from 'crypto-js';

	import {bus} from '../../../main';

	export default {
		name: 'Detail',
		props: ['properties'],
		components: {
		HotTable
		},
		computed: {
			sheetSettings() {
				let settings = this.$store.getters.sheetSettings;
				return settings;
			},
			filteredDataArray() {;
				return this.data.filter((option) => {
					return option.toString().toLowerCase().indexOf(this.companyName.toLowerCase()) >= 0
				});
			}
		},
		data() {
			return {
				remoteHost: '',
				remoteUserName: '',
				fileExtension: '',

				mainName: '',
				subName: '',
				menuData: [],
				saveMode: '',
				put_label:'',

				mid: '', 
				uid: '', 
				msid: '',
				ssid: '',
				userHeader:[],
				name: '',
				runFile: '',
				reportDataFile:'',
				reporterFile:'',
				resultMenu:'',
				outPutDir:'',
				resultMenu_array: [],
				param_array: [],
				usedCode: '',
				type:'',
				version:'',
				flag: false,
				defaultSwitched:'',
				defaultWatch:'',
				pipelineDefault:'',

				/* Loading */
				isLoading: false,
				isFullPage: true,

				data: [],
				selected: null,

				task:[],
				selTask:[],
			}
		},
		beforeDestroy(){
			bus.$off('menu_data');
		},
		created() {
			bus.$on('menu_data', (data)=>{
				this.menuData = data;
				this.modeFilter();
				this.classifyHeader();
				for(let i in this.menuData){
					if(this.menuData[i].mains == "Result"){
						//result menu들 불러오기
						for(let j in this.menuData[i].subs){
							this.resultMenu_array.push({menuName:this.menuData[i].subs[j].menuName, menuId : this.menuData[i].subs[j].id});
						} 
					}
				}
				//메뉴의 아이디와 메뉴 이름을 가져오기 
			});

			this.uid = this.properties.uid;
			this.mid = this.properties.mid;
			this.defaultWatch = 'Default'
		},
		mounted() {
		
		},
		methods : {
			selTaskHandler() {
				this.param_array = [];
				console.log(this.selTask);
				this.runFile = this.selTask.runFile;
				this.reporterFile = this.selTask.reporterFile;
				this.reportDataFile = this.selTask.reportDataFile;
				this.type = this.selTask.type;
				this.outPutDir = this.selTask.outPutDir;
				this.remoteHost = this.selTask.remoteHost;
				this.remoteUserName = this.selTask.remoteUserName;
				this.fileExtension = this.selTask.fileExtension;
				for (let i in this.selTask.param) {
					if (i > 1) {
						this.param_array.push({key: this.selTask.param[i].key, fixed: true, value:this.selTask.param[i].value, message:this.selTask.param[i].message});
					}
				}
			},
			async classifyHeader() {
				let data = common.menuHeader(this.properties.mid, this.menuData, 3);
				this.mainName = data[0];
				this.subName  = data[1];
				this.msid = data[2];
				this.userHeader = data[3];
				const task = await this.$axios.get(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/task');
				this.task = task.data;
				//console.log("제일 처음 실행")
				//console.log(this.task);
				let json = {"name": "Create a pipeline"}
				this.task.push(json);
				
				//console.log("task check")
				//console.log(this.task)
					
			},
			goList() {
				if (this.flag) {
					//등록, 수정 완료시 바로 리스트로 가기때문에 
				} else {
					const result = confirm("You didn't do anything. Would you like to go to the list?");
					if (result) this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.mid, type:'list'}});
					else return false;
				}
			},
			async modeFilter() { //create, update 구분 
				if (this.properties.uid) {//update
					this.saveMode = 'update';
					//update 일 경우 insert인 경우를 분리
					//update data가져오기
					//console.log("데이터 확인--------------------------")
					//console.log(this.properties.uid)
					await this.$axios.get(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/detail', {params:{'id':this.properties.uid}})
					.then(res => {
						for (let i in this.task) {
								this.selTask = this.task[i]
						}
						for (let i in res.data.param) {
							if (i >= 0) {
							this.param_array.push({key: res.data.param[i].key,value:res.data.param[i].value, fixed: true, message:res.data.param[i].message});
						}
						}
						//console.log("파이프라인 디폴트 값 찾기")
						//console.log(res.data.pipelineDefault)
						//set default
						if(res.data.pipelineDefault == 1){
							this.defaultSwitched = 'Yes'; 
						}else{
							this.defaultSwitched = 'No'
						}

						this.pipelineDefault = res.data.pipelineDefault;
						this.name = res.data.name;
						this.runFile = res.data.runFile;
						this.reportDataFile = res.data.reportDataFile;
						this.reporterFile = res.data.reporterFile;
						this.resultMenu = res.data.resultMenu;
						this.outPutDir = res.data.outPutDir;
						this.type = res.data.type;
						this.remoteHost = res.data.remoteHost;
						this.remoteUserName = res.data.remoteUserName;
						this.fileExtension = res.data.fileExtension;
						this.usedCode = res.data.usedCode;
						this.version = res.data.version;
						//console.log(this.version);
						this.param_array = res.data.param;
					}).catch((error) => {});
				} else {//insert
					this.saveMode = 'insert';
					this.defaultSwitched ='No';
					this.pipelineDefault=0;
				}
			},
			async deleteData(){
						var result = confirm('Are you going to delete the pipeline?');
								if (result) {
									const pipelineNum = {pipelineId:this.properties.uid}
									this.$axios.post(this.$apiHost + '/'+this.$route.name.substring(0, this.$route.name.indexOf('_'))+ "/delete", pipelineNum)
									.then((res) => {
										if(res.data){
											this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.mid, type:'list'}});
										}else{
											this.$buefy.dialog.alert({
													message: 'Pipeline not deleted',
													size: 'is-medium',
													type: 'is-danger'
												});
										}
									});
								} else {
									return false;
								}
			},
			async createData() {
					if (!this.name) {
						this.$buefy.dialog.alert({
							message: 'Please enter Pipeline Name.',
							size: 'is-medium',
							type: 'is-danger'
						});
						this.$refs.name.focus();
						return false;

					} else if (!this.runFile) {
						this.$buefy.dialog.alert({
							message: 'Please enter Pipeline Shell Script runFile.',
							size: 'is-medium',
							type: 'is-danger'
						});
						this.$refs.runFile.focus();
						return false;
					}
					  else if (!this.outPutDir) {
						this.$buefy.dialog.alert({
							message: 'Please enter Pipeline Shell Script outPutDir.',
							size: 'is-medium',
							type: 'is-danger'
						});
						this.$refs.outPutDir.focus();
						return false;
					}
					else if (!this.type) {
						this.$buefy.dialog.alert({
							message: 'Please select a type.',
							size: 'is-medium',
							type: 'is-danger'
						});
						this.$refs.type.focus();
						return false;
					}else if(!this.resultMenu){
						this.$buefy.dialog.alert({
							message: 'Please select a result.',
							size: 'is-medium',
							type: 'is-danger'
						});
						this.$refs.resultMenu.focus();
						return false;
					} else if (!this.remoteHost) {
						this.$buefy.dialog.alert({
							message: 'Please select a remote host.',
							size: 'is-medium',
							type: 'is-danger'
						});
						this.$refs.remoteHost.focus();
						return false;
					} else if (!this.remoteUserName) {
						this.$buefy.dialog.alert({
							message: 'Please select a remote username.',
							size: 'is-medium',
							type: 'is-danger'
						});
						this.$refs.remoteUserName.focus();
						return false;
					} else if (!this.fileExtension) {
						this.$buefy.dialog.alert({
							message: 'Please select a filename Extension.',
							size: 'is-medium',
							type: 'is-danger'
						});
						this.$refs.fileExtension.focus();
						return false;
					}
					if (confirm('Would you like to register?')) {
						const name = this.name;
						const runFile = this.runFile;
						const param = this.param_array;
						const usedCode = this.usedCode;
						const uid = this.uid;
						const msid = this.msid;
						//const creator =	this.userHeader;
						const reportDataFile = this.reportDataFile;
						const reporterFile = this.reporterFile;
						const resultMenu = this.resultMenu;
						const outPutDir = this.outPutDir;
						const type = this.type;
						const remoteHost = this.remoteHost;
						const remoteUserName = this.remoteUserName;
						const fileExtension = this.fileExtension;
						const pipelineDefault = this.pipelineDefault;

						//let groupId = '';
						//if(this.properties.uid){
						//	groupId = this.groupId;
						//}else{
						//	groupId = this.selTask.id;
						//}
						//console.log(groupId)
						const params = common.isNull(usedCode) ? {uid, msid, name, runFile, param, reportDataFile, reporterFile, resultMenu, outPutDir, type, pipelineDefault, remoteHost, remoteUserName, fileExtension} : {uid, msid, name, runFile, param, usedCode, reportDataFile, reporterFile, resultMenu, outPutDir, type, pipelineDefault, remoteHost, remoteUserName, fileExtension};
						this.$axios.post(this.$apiHost + '/'+this.$route.name.substring(0, this.$route.name.indexOf('_'))+ "/makePipeline", params)
						.then((res) => {
						if (res.data.deduplication) {//중복
								alert(res.data.msg);
								this.userId = "";
								this.$refs.userId.focus();
							} else if (!res.data.deduplication) { //등록 완료
								var result = confirm('You have created user. Would you like to leave?');
								if (result) {
									this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.mid, type:'list'}});
								} else {
									return false;
								}
							}
						});

					}
				
			},
			addParameter() {
				this.param_array.push({key: '',value:'',message:'', fixed: false })
				
			},
			delParameter(row){
				this.param_array.splice(row, 1)
			},
			chgParameter(row, idx, $event){
				if(idx =='fixed') this.$set(this.param_array[row], idx, $event.target.checked)
				else this.$set(this.param_array[row], idx, $event.target.value)
			},
			chgUsedcode($event, idx){
				if(idx === 1) this.usedCode = 1;
				else this.usedCode = 0;
			},
			typeCheck($event, idx){
				this.type='';
				if(idx === 1) this.type = 'single';
				else this.type = 'group';
			},
			serverCheck($event, idx){
				this.remoteHost='';
				if(idx === 1) this.remoteHost = 'accu01';
				else this.remoteHost = 'accu02';
			},
			extensionCheck($event, idx){
				this.fileExtension='';
				if(idx === 1) this.fileExtension = 'python';
				else this.fileExtension = 'shell';
			},
			defaultCheck(idx){
				const type = this.type;
				let defaultResult='';

				if(this.defaultSwitched == 'Yes'){
					
					//1 sigle, group 중 default 로 설정된 기존 데이터 가져옴
					this.$axios.post(this.$apiHost+'/' + this.$route.name.substring(0,this.$route.name.indexOf('_')) + '/default', {type})
					.then((res) => {
						defaultResult = res.data;
						if(!common.isNull(defaultResult)){//default 설정이 되어있다면
							var pipelineName = res.data[0].name;
							var pipelineId = res.data[0].id; //기존 디폴트설정 파이프라인 아이디
							var txt ='pipeline called "'+ pipelineName +'" is already set up by default.<br>\nAre you going to set the default with this pipeline\n rather than the existing default? ';	
							//var result = confirm(txt);
							var resultEx = this.$buefy.dialog.confirm({
								title: 'Default setting',
								message: txt,
								cancelText: 'Disagree',
								confirmText: 'Agree',
								type: 'is-success',
								onConfirm: () => {this.$buefy.toast.open('User agreed');
										//1. 기존 default 설정 파이프라인 1 => 0 수정
												console.log("onConfirm agree")
												this.$axios.post(this.$apiHost+'/' + this.$route.name.substring(0,this.$route.name.indexOf('_')) + '/canceldefault', {pipelineId})
												.then((res) =>{
													console.log(res.data)
												});
			
										//2. 현재 default 설정 파이프라인 0 => 1 수정
											if(this.saveMode == 'update'){
												var thisPipelineId =this.properties.uid;
												this.$axios.post(this.$apiHost+'/' + this.$route.name.substring(0,this.$route.name.indexOf('_')) + '/setdefault', {thisPipelineId})
												.then((res) =>{
													console.log(res.data)
												});
											this.pipelineDefault = 1;	
										}else{//3. 새로 파이프라인을 만드는 경우
											this.pipelineDefault = 1;
										}
								}
							});
							//console.log(resultEx)

						}else{//기존에 설정된 default가 없다면
								var resultEx2 = this.$buefy.dialog.confirm({
								title: 'Default setting',
								message: 'There is no pipeline set to the default value yet.<br>Do you want to set it up?',
								cancelText: 'Disagree',
								confirmText: 'Agree',
								type: 'is-success',
								onConfirm: () => {this.$buefy.toast.open('User agreed');
										//1. 현재 default 설정 파이프라인 0 => 1 수정
										if(this.saveMode == 'update'){
												var thisPipelineId =this.properties.uid;
											this.$axios.post(this.$apiHost+'/' + this.$route.name.substring(0,this.$route.name.indexOf('_')) + '/setdefault', {thisPipelineId})
											.then((res) =>{
												console.log(res.data)
											});
											this.pipelineDefault = 1;
										}else{//2. 새로 파이프라인을 만드는 경우
											this.pipelineDefault = 1;
										}
								}
							});
						}
	
					});

				}else if(this.defaultSwitched == 'No'){//No 일때
					this.pipelineDefault = 0;
					//alert("NO")
				}

			}
		},
		watch: {
		},
	}
</script>
<style src="../../../../node_modules/handsontable/dist/handsontable.full.css"></style>
<style scoped>
	@import '../../../assets/css/buefy.css';
</style>


// WEBPACK FOOTER //
// src/views/Analysis/Pipeline/TaskDetailForm.vue